export default "__VITE_ASSET__45f6188e__"